
export default function GetStartedSection() {
  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="bg-gradient-to-r from-[#2D7F3E] to-[#245A2E] rounded-2xl p-8 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Ready to Transform Your Team's Performance?
            </h3>
            <p className="text-xl mb-8 text-green-100">
              Request your customised training proposal today and take the first step towards excellence
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="btn btn-white btn-lg">
                Request Your Customised Training Proposal
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#2D7F3E] transition-colors whitespace-nowrap">
                Call Us: +27 10 224 0406
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
